export default "__VITE_ASSET__DqY_66EU__"